module.exports = __webpack_public_path__ + "img/CombineHarvester.03745dc4.png";